
import React from "react";

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000
  },
  modal: {
    width: "auto",
    height: "250px",
    background: "#fff",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 5px 20px rgba(0,0,0,0.3)"
  },
  header: {
    background: "#dc3545",
    padding: "15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  close: {
    color: "#fff",
    fontSize: "20px",
    cursor: "pointer"
  },
  body: {
    padding: "30px",
    fontSize: "16px"
  },
  footer: {
    padding: "8px",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px"
  },
  cancelBtn: {
    padding: "8px 16px",
    background: "#eee",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer"
  },
  confirmBtn: {
    padding: "8px 16px",
    background: "#dc3545",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer"
  }
};

const ConfirmAlert = ({ DeleteSubQuestion, onClose, onConfirm }) => {
  if (!DeleteSubQuestion) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        
        {/* Header */}
        <div style={styles.header}>
          <h4 style={{ margin: 0, color: "#fff" }}>Confirm Action</h4>
          <span style={styles.close} onClick={onClose}>×</span>
        </div>

        {/* Body */}
        <div style={styles.body}>
          <p> The dependent sub-question for the parent question deleted.<br />
             Are you sure you want to delete this record?</p>
        </div>

        {/* Footer */}
        <hr />
        <div style={styles.footer}>
          <button style={styles.cancelBtn} onClick={onClose}>
            Cancel
          </button>
          <button style={styles.confirmBtn} onClick={onConfirm}>
            Confirm
          </button>
        </div>

      </div>
    </div>
  );
};

export default ConfirmAlert;